import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DownloadPaymentReconciliationCSVRequest {
  token: string;
  apiColumnFilters: any;
  apiSorting: any;
}

const downloadPaymentReconciliationCSV = async ({
  token,
  apiColumnFilters,
  apiSorting,
}: DownloadPaymentReconciliationCSVRequest) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-repayment/download-payment-reconciliation-csv`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          columnFilters: apiColumnFilters,
          sorting: apiSorting,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default downloadPaymentReconciliationCSV;
